<template>
  <div style="height: 100%">
    <div id="cardQ">
      <div v-if="!mute" id="question" @click="textToSpeech(english)">
        <i class="fas fa-volume-down clickable"></i>
      </div>
      <div v-else id="question">
        {{english}}
      </div>
      <div id="tools">
        <i class="fas fa-volume-up clickable" v-if="!mute" @click="set_mute(true)"></i>
        <i class="fas fa-volume-mute clickable" v-else @click="set_mute(false)"></i>
      </div>

      <!--
            <syllables-answer
                :syllables="syllablesList"
                :goodAnswer="goodAnswer"
                :answerTrad="answerTrad"
                :sameLanguage="sameLanguage"
                :pass="pass"
                @goodAnswer="giveAnswer">
            </syllables-answer>
            -->
      <spelling-answer
          :answer="english"
          :pass="pass"
          :sameLanguage="sameLanguage"
          :answerTrad="answerTrad"
          @goodAnswer="giveAnswer">
      </spelling-answer>

      <div class="bigRoundAngles flexwrap centercenter clickable red" style="padding: 2vw; justify-items: flex-end"
           @click="giveAnswer(false); pass = true" v-if="isMobile">
        <span>Passer</span> <i class="fas fa-arrow-right" style="margin-left: 2vw"></i>
      </div>
          </div>


  </div>
</template>

<script>
      import {mapActions, mapGetters} from 'vuex'
      import textToSpeech from '../plugins/texttospeech'
      import Vue from 'vue'
      Vue.use(textToSpeech)

      export default {
      name: "vocabularySpeechToText",
        components: {
          spellingAnswer: () => import(/* webpackPrefetch: true */ '@/components/spellingAnswer.vue')
        },
        props: {
          english: String,
          french: String,
          otherWords: Array,
          answerLanguage: String
        },

        computed: {
        ...mapGetters('global', [
        'isMobile',     'mute'
        ]),
          pass: {
            get() {
              return this.passNext
            },
            set(value) {
              this.passNext = value
            }
          }
        },

        created() {
          if(!this.mute) {
            this.$textToSpeech(this.english, this.url1, this.url2, this.voice)
          }

          if(this.answerLanguage === 'fr') {
            this.goodAnswer = this.french;
            this.answerTrad = this.english
          }
          else {
            this.goodAnswer = this.english;
            this.answerTrad = this.french
            this.sameLanguage = true;
          }
        },

        methods: {
        ...mapActions('global', [
            'set_mute',
        ]),
    textToSpeech(word) {
      /*this.$textToSpeech(word)*/
      let currentUrl = ''
      let currentVoice = "Matthew"
      if(this.voice===1){
        currentUrl = this.url1
      }
      else{
        currentUrl = this.url2
        currentVoice = "Salli"
      }
      if(currentUrl == ''){
        // Initialize the Amazon Cognito credentials provider
        AWS.config.region = 'eu-west-3';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({IdentityPoolId: 'eu-west-3:acfb193c-b37d-4ee9-bcbd-209283d4a2ec'});
        var speechParams = {
          OutputFormat: "mp3",
          SampleRate: "22050",
          Text: word,
          TextType: "text",
          VoiceId: currentVoice
        };
        var polly = new AWS.Polly({apiVersion: '2016-06-10'});
        var signer = new AWS.Polly.Presigner(speechParams, polly)
        // Create presigned URL of synthesized speech file
        signer.getSynthesizeSpeechUrl(speechParams, (error, url) => {
          if (!error) {
            if(this.voice===1) {
              this.url1 = url
              this.voice = 2
            }
            else{
              this.url2 = url
              this.voice = 1
            }
            new Audio(url).play();
          }
        })
      }
      else{
        new Audio(currentUrl).play();
        if(this.voice===1){
          this.voice = 2
        }
        else{
          this.voice = 1
        }
      }
    },
          giveAnswer(isCorrect) {
            let timeout = 800;
            if(!isCorrect) {
              timeout = 2000;
            }
            window.setTimeout(() => (this.$emit('answer', isCorrect)), timeout)
          },
        },

        data() {
          return {
            url1: '',
            url2: '',
            voice: 1,
            syllablesList: [],
            count: 0,
            goodAnswer: '',
            answerTrad: '',
            sameLanguage: false,
            passNext: false,
          }

        }
      }
</script>

<style scoped>
#cardQ {
  position: relative;
  padding: 2.5vw;
  display: grid;
  justify-content: center;
  justify-items: center;
  height: calc(100% - 5vw);
  grid-template-rows: auto 1fr;
  width: 100%;
  background-color: var(--color2);
}

#question {
  align-self: center;
  font-size: 300%;
  font-weight: bold;
}

#tools {
  position: absolute;
  top: 1vw;
  right: 1vw;
  color: #c9c9c9;
  transition-property: color;
  transition-duration: .5s;
}

@media screen and (max-device-width: 767px) {
  #cardQ {
    height: calc(100% - 15vw);
    grid-template-rows: auto 1fr 15vw;
  }

  #tools {
    top: 0vw;
    right: 4vw;
  }
}
</style>
